import { render, staticRenderFns } from "./AssociationIntro.vue?vue&type=template&id=471519ba&scoped=true"
import script from "./AssociationIntro.vue?vue&type=script&lang=js"
export * from "./AssociationIntro.vue?vue&type=script&lang=js"
import style0 from "./AssociationIntro.vue?vue&type=style&index=0&id=471519ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471519ba",
  null
  
)

export default component.exports